<template>
  <!-- Ячейка 1 -->
  <div>
    <div v-if="!loading">
      <div class="text-gray-600 mb-4" v-if="!error">
        <p class="text-gray-600 mb-2">{{ tariffData.name }}</p>
        <p class="text-gray-600 mb-2">Размер: {{ tariffData.logSize }} Mb</p>
        <p class="text-gray-600 mb-2">Хранение: {{ tariffData.logDays }} дн.</p>

        <p v-if="tariffData.freeEndDate" class=" mb-2 mt-2">
          <span class="text-gray-600">Бесплатно до</span>: <span class="text-green-800 font-bold">{{ tariffData.freeEndDate }}</span>
        </p>

        <button @click.prevent="openModal" class="px-4 py-2 mt-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors cursor-pointer">
          {{ "Изенить" }}
        </button>
      </div>
      <p class="text-red-600" v-else>
        {{ typeof error === "string" ? error : 'Ошибка' }}
      </p>
    </div>
    <LoaderIcon v-if="loading" />
  </div>

  <ModalWindow :show="confirmModal.show" :showDone="false" @close="closeModal" :weight="200" title="Смена тарифа">
    <div v-if="loadingTariffList">
      Загрузка...
    </div>
    <div v-else>
      <h3 class="hidden">#{{tariffData.id}}</h3>
      <div>
        <table class="min-w-full divide-y divide-gray-200 text-left">
          <tr v-for="(tariff, i) in tariffList" v-bind:key="i" :class="tariffData.id === tariff.id ? 'text-gray-400' : 'text-gray-800'">
            <td class="px-6 py-2 font-xl text-gray-900">{{tariff.name}}</td>
            <td class="px-6 py-2 whitespace-nowrap text-2xl font-semibold text-gray-900">{{tariff.logDays}} дн</td>
            <td class="px-6 py-2 whitespace-nowrap text-2xl font-semibold text-gray-900">{{tariff.logSize}} Mb</td>
            <td class="px-6 py-2 whitespace-nowrap text-xl font-medium text-gray-900">{{tariff.price}} руб.</td>
            <td class="px-6 py-3 font-medium text-gray-900">
              <button
                  @click.prevent="selTariff(tariff.id)"
                  :disabled="tariffData.id === tariff.id"
                  class="px-4 py-2  text-white font-medium rounded-md cursor-pointer"
                  :class="tariffData.id === tariff.id ? 'bg-gray-200 hover:bg-gray-600' : 'bg-blue-400 hover:bg-blue-600'"
              >Выбрать тариф
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </ModalWindow>
</template>

<script>
import ModalWindow from "@/components/modal/ModalWindow.vue";
import LoaderIcon from "@/components/LoaderIcon.vue";
//import Loading from '@/static/loading.svg';

export default {
  name: 'TariffBlock',
  components: {ModalWindow, LoaderIcon},
  data() {
    return {
      tariffList: null,
      tariffData: null,
      error: null,
      loading: true,
      loadingTariffList: true,
      loadingTariffListError: null,
      confirmModal: {
        title: "Создание нового ключа",
        message: "Создать новый ключ доступа?",
        show: false,
      }
    }
  },
  mounted() {
    this.loadData();
  },
  computed: {
    //
  },
  methods: {
    closeModal: function () {
      this.confirmModal.show = false;
    },
    selTariff: function (tariffId) {
      if (typeof tariffId === "undefined") {
        alert("invalid id!");
      }

      console.log("set tariff " + tariffId)

      let c = this;
      this.axios.post('/api/settings/tariff', {tariffId: tariffId}).then(function(response) {
        console.log(response.data);
        c.tariffData = response.data.data;
      }).catch(function(err) {
        console.log(err.status);
        c.loadingTariffListError = true;
      }).finally(function() {
        c.confirmModal.show = false;
        c.loadingTariffList = false;
      });
    },
    openModal: function () {
      this.confirmModal.show = true;
      this.loadTariffList()
    },
    loadTariffList: function () {
      console.log("load tariff list")
      let c = this;
      c.tariffList = null;
      c.loadingTariffList = true;
      c.loadingTariffListError = false;
      this.axios.get('/api/public/tariff').then(function(response) {
        console.log(response.data);
        c.tariffList = response.data.data;
      }).catch(function(err) {
        console.log(err.status);
        c.error = true;
      }).finally(function() {
        c.loadingTariffList = false;
      });
    },
    loadData: function () {
      console.log("load tariff")
      let c = this;
      c.tariffData = null;
      c.loading = true;
      c.error = false;
      this.axios.get('/api/settings/tariff').then(function(response) {
        console.log(response.data);
        c.tariffData = response.data.data;
        c.loading = false;
      }).catch(function(err) {
        console.log("TARIFF", err, err.response.data?.error);
        c.loading = false;
        c.error = true;
        if (typeof err.response.data.error === "string") {
          c.error = err.response.data.error;
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
